import styled from 'styled-components';

export const Container = styled.footer`
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: solid 1px var(--color-grey97);
  padding: 15px 20px;
`;

export const Text = styled.p`
  font-size: var(--font-size15);
`;
